import React, { useState } from 'react'
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Space
} from 'antd'
import {
  dateRule,
  inputRule,
  radioRule,
  selectRule
} from '../../../utils/rules'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  EVIDENCES,
  PAYMENTS,
  PRODUCT_MANAGEMENT,
  TRANSPORTS
} from '../../../utils/constants'
import MaterialList from '../../../components/MaterialList'
import { isEmpty } from 'lodash'
import MaterialItem from '../../../components/MaterialItem'
import moment from 'moment'

const NormalForm = (props) => {
  const { materialState, setMaterialState, materials } = props
  const [visible, setVisible] = useState(false)

  function onClick() {
    setVisible(true)
  }

  function onOk() {
    setVisible(false)
  }

  function onClose() {
    setVisible(false)
  }

  const buttonAdd = (
    <div
      onClick={() => onClick()}
      style={{
        backgroundColor: '#6ebf4b',
        padding: '5px',
        width: '30px',
        textAlign: 'center',
        color: 'white',
        borderRadius: '50%',
        cursor: 'pointer'
      }}>
      <PlusOutlined />
    </div>
  )

  const buttonEdit = (
    <div
      onClick={() => onClick()}
      style={{
        backgroundColor: '#6ebf4b',
        padding: '5px',
        width: '30px',
        textAlign: 'center',
        color: 'white',
        borderRadius: '50%',
        cursor: 'pointer'
      }}>
      <EditOutlined />
    </div>
  )

  const disabledDate = (current) => {
    const customDate = moment().add('7', 'days')
    const pastDate = moment().subtract('1', 'days')
    return (
      (current && current < moment(pastDate)) || current > moment(customDate)
    )
  }

  return (
    <div>
      <MaterialList
        visible={visible}
        onOk={onOk}
        onClose={onClose}
        materials={materials}
        materialState={materialState}
        setMaterialState={setMaterialState}
      />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item label="เลือกสินค้า">
            {!isEmpty(materialState) ? (
              <Space>
                <MaterialItem material={materialState} />
                {buttonEdit}
              </Space>
            ) : (
              buttonAdd
            )}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="productManagement"
            label="เลือกรูปแบบการจัดการสินค้า (เลือกได้มากกว่า 1)"
            {...selectRule}>
            <Checkbox.Group>
              <Row gutter={[8, 8]}>
                {PRODUCT_MANAGEMENT.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Checkbox value={item.value}>{item.name}</Checkbox>
                    </Col>
                  )
                })}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="transports"
            label="ลักษณะรถขนส่งที่รับ (เลือกได้มากกว่า 1)"
            {...selectRule}>
            <Checkbox.Group>
              <Row gutter={[8, 8]}>
                {TRANSPORTS.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Checkbox value={item.value}>{item.name}</Checkbox>
                    </Col>
                  )
                })}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Row gutter={8}>
            <Col span={12}>
              <Row gutter={8} align="middle">
                <Col>
                  <Form.Item
                    label="ปริมาณรับขั้นต่ำต่อเที่ยว"
                    name="amountMinimum"
                    {...inputRule}>
                    <InputNumber
                      step="0.01"
                      min={0}
                      style={{ width: '200px' }}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <span>{materialState.unit}</span>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={8} align="middle">
                <Col>
                  <Form.Item label="ราคา" name="price" {...inputRule}>
                    <InputNumber
                      step="0.01"
                      min={0}
                      style={{ width: '200px' }}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <span>บาท/หน่วย</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Form.Item label="จ่าย VAT เพิ่ม" name="includeVat" {...radioRule}>
            <Radio.Group>
              <Radio value={true}>ได้</Radio>
              <Radio value={false}>ไม่จ่าย VAT</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="ยืนราคาถึงวันที่ (เลือกได้สูงสุดไม่เกิน 7 วัน)"
            name="expirationDate"
            {...dateRule}>
            <DatePicker disabledDate={disabledDate} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="presaleDocument"
            label="หลักฐานผู้ขายที่ต้องการ (เลือกได้มากกว่า 1)"
            {...selectRule}>
            <Checkbox.Group>
              <Row gutter={[8, 8]}>
                {EVIDENCES.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Checkbox value={item.value}>{item.name}</Checkbox>
                    </Col>
                  )
                })}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="ตัวอย่างสินค้าก่อนขาย"
            name="productSample"
            {...radioRule}>
            <Radio.Group style={{ width: '100%' }}>
              <Row gutter={8}>
                <Col span={8}>
                  <Radio value="ไม่ต้องการ">ไม่ต้องการ</Radio>
                </Col>
                <Col span={8}>
                  <Radio value="รูปภาพสินค้า">รูปภาพสินค้า</Radio>
                </Col>
                <Col span={8}>
                  <Radio value="ตัวอย่างสินค้า">ตัวอย่างสินค้า</Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="payments" label="การจ่ายเงิน" {...selectRule}>
            <Radio.Group>
              <Row gutter={[8, 8]}>
                {PAYMENTS.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Radio value={item.value}>{item.name}</Radio>
                    </Col>
                  )
                })}
              </Row>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="เงื่อนไขอื่นๆ" name="remark">
            <Input.TextArea autoSize={{ minRows: 4 }} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}

export default NormalForm



// WEBPACK FOOTER //
// ./src/pages/AccountFactory/NormalForm/index.js